module.exports = __webpack_public_path__ + "static/favicon-158316476e81781ced01631f52d88741.png";